import { render, staticRenderFns } from "./AlertsSuspiciousTraffic.vue?vue&type=template&id=ad048ee2&scoped=true&"
import script from "./AlertsSuspiciousTraffic.vue?vue&type=script&lang=js&"
export * from "./AlertsSuspiciousTraffic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad048ee2",
  null
  
)

export default component.exports